import { render } from "./ReviewList.vue?vue&type=template&id=e6d7bf6c&ts=true"
import script from "./ReviewList.vue?vue&type=script&lang=ts"
export * from "./ReviewList.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__